import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

export const Wrapper = styled.div``
export const TableTit = styled.div`
  font-size: 0.7rem;
  p {
    padding-bottom: 0.4rem;
  }
`

export const TranNumSpan = styled.span`
  padding-left: 0.1rem;
  color: #0097fe;
  font-weight: 600;
`

export const TableLink = styled(Link)`
  color: #0097fe;
  font-family: Roboto;
  font-weight: 400;
`
